

export const ADVANCE_AHEAD = 1
export const NORMAL_TURN_RIGHT = 2
export const EXTENDED_TRIAL_PERIOD = 3
export const OUT_OF_PHASE = 4

export const regularResults = [
  {title: '提前转正', value: ADVANCE_AHEAD},
  {title: '正常转正', value: NORMAL_TURN_RIGHT},
  {title: '延长试用期', value: EXTENDED_TRIAL_PERIOD},
  {title: '淘汰', value: OUT_OF_PHASE}
]

export const getRegularResult = (value) => {
  if (typeof value !== 'number') {
    value = Number(value)
  }
  const result = regularResults.find(item => item.value === value)
  return typeof result === 'undefined' ? '-' : result.title
}


// WEBPACK FOOTER //
// ./src/config/regularResult.js